<template>
  <div>
    <va-inner-loading :loading="loader">
      <va-card class="mb-4">
        <div
          class="d-flex justify--space-between align-items-start flex-wrap gap-2"
        >
          <h1>Все товары {{ productsbycategory?.total != null ? `(${productsbycategory.total})` : "" }}</h1>
          <div class="ml-auto d-flex align-items-center flex-wrap gap-2">
            <va-button color="primary" @click="openImportCSVModal">
              Импорт товаров
            </va-button>
            <va-button color="info" @click="openCreatePage">
              Добавить товар
            </va-button>
          </div>
        </div>
        <div v-if="!loading && categories.length" style="max-width: 350px">
          <va-select
            v-model="productSelectCategory"
            label="Категории"
            text-by="name"
            max-height="300px"
            chips
            position="bottom"
            :options="categories"
            @input="setCategory(productSelectCategory)"
          />
        </div>
      </va-card>

      <products-table class="mb-4" />
      <ImportCSVModal ref="importCSVModal" @imported="loadData" />
    </va-inner-loading>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
import productsTable from "@/components/products/products-table.vue";
import ImportCSVModal from "@/components/products/ImportCSVModal.vue";

export default {
  name: "ProductsList",
  components: {
    productsTable,
    ImportCSVModal,
  },
  data() {
    return {
      productSelectCategory: "",
      loading: false,
    };
  },
  computed: {
    ...mapGetters("product", ["getAllCategories"]),
    ...mapState("product", ["productData", "productsbycategory"]),
    ...mapGetters({
      loader: "isLoading",
      categories: "product/getCategoriesWithStaticOption",
    }),
  },
  watch: {
    categories: {
      handler(newCategories) {
        if (
          newCategories?.length > 0 &&
          !this.$route.query.category &&
          !this.productSelectCategory
        ) {
          const allProductsOption = newCategories.find(
            (cat) => cat.value === "all_products_without_category"
          );
          if (allProductsOption) {
            this.productSelectCategory = allProductsOption;
          }
        }
      },
      immediate: true,
    },
  },
  async created() {
    await this.loadData();
  },
  methods: {
    ...mapActions({
      getProductsByCategory: "product/getProductsByCategory",
      getProductData: "product/getProductData",
    }),
    ...mapMutations("product", ["SET_PRODUCTS_WITHOUT_CATEGORY"]),

    async loadData() {
      const needsMetaData =
        !this.productData?.categories ||
        this.productData.categories.length === 0;

      const loadMetaData = needsMetaData
        ? (async () => {
            this.loading = true;
            try {
              await this.getProductData();
            } catch (error) {
              this.showError("Ошибка загрузки метаданных", error);
            } finally {
              this.loading = false;
            }
          })()
        : Promise.resolve();

      const loadProducts = (async () => {
        try {
          const page = parseInt(this.$route.query.page, 10) || 1;
          if (this.$route.query.category) {
            await this.getProductsByCategory({
              category: this.$route.query.category,
              page,
            });
          } else {
            this.SET_PRODUCTS_WITHOUT_CATEGORY(true);
            const allProductsOption = this.categories?.find(
              (cat) => cat.value === "all_products_without_category"
            );
            if (allProductsOption) {
              this.productSelectCategory = allProductsOption;
            }
            await this.getProductsByCategory({
              category: "all_products_without_category",
              page,
            });
          }
        } catch (error) {
          this.showError("Ошибка загрузки товаров", error);
        }
      })();

      await Promise.all([loadMetaData, loadProducts]);
    },

    showError(title, error) {
      if (this.$notify) {
        this.$notify({
          type: "error",
          title,
          message: error.message || "Не удалось загрузить данные",
        });
      }
    },

    openCreatePage() {
      this.$router.push("/admin/products/create");
    },

    setCategory(category) {
      if (category.value === "all_products_without_category") {
        this.SET_PRODUCTS_WITHOUT_CATEGORY(true);
        this.getProductsByCategory({ category: category.value, page: 1 });
        if (Object.keys(this.$route.query).length !== 0) {
          this.$router.replace({ query: null });
        }
      } else {
        this.SET_PRODUCTS_WITHOUT_CATEGORY(false);
        if (category.slug) {
          this.getProductsByCategory({ category: category.slug, page: 1 });
          this.$router
            .push({
              path: "/admin/products",
              query: { category: category.slug },
            })
            .catch(() => {
              if (this.$route.query.category === category.slug) {
                return false;
              }
            });
        }
      }
    },

    openImportCSVModal() {
      this.$refs.importCSVModal.show();
    },
  },
};
</script>

<style lang="scss"></style>
